<div [class]="skinName">
  <!-- phone Number verification pop up -->
  @if (step === 1) {
    <h2 class="uk-modal-title">{{ configService.localeKeys['account.edit_phone_numb.text'] || 'Edit Your Phone Number'}}</h2>
  }
  @if (step === 1) {
    <div class="input-container">
      <p class="text-center">{{ configService.localeKeys['my_acc_edit_num_desc1'] || 'You may edit your phone number below.'}}</p>
      <form [formGroup]="changePhoneForm" class="phone-number-form" name="changePhoneForm" method="post" novalidate>
        <label>{{ configService.localeKeys?.['account.phone_number.text'] || 'Phone Number'}}</label>
        <div class="phone-number-input">
          @if (selectedPhoneCodeObj?.login_with_mobile_enabled && settingsService?.loginWithMobileEnabled) {
            <li class="dropdown phone-number-dropdown">
              <a class="dropdown-toggle" data-toggle="dropdown" [(ngModel)]="selectedPhoneCodeObj.phone_code" name="language" ngDefaultControl> <img class="country-code-flag" [src]="settingsService.imagePath + selectedPhoneCodeObj.flag"> {{'+' + selectedPhoneCodeObj.phone_code}}
                <img loading="lazy" class="phone-number-caret" src="branding/theme/assets/static_assets/ic-down.svg">
              </a>
              <ul class="dropdown-menu phone-number-dropdown-menu scrollable-menu" role="menu">
                <div class="border-bot phone-number-profile">
                  @for (value of phoneCodes; track value; let index = $index) {
                    <li class="phone-number-list" (click)="setPhoneCode(value)">
                      <img class="country-code-flag" [src]="settingsService.imagePath + value?.flag">
                      <a role="menuitem" tabindex="-1">{{'+' + value.phone_code}}</a>
                    </li>
                  }
                </div>
              </ul>
              <span class="country-code-separator"></span>
            </li>
          }
          <input type="tel" name="userMobile" inputmode="tel" formControlName="mobile" class="form-control"
            (change)="changePhone()" (keydown)="onKeyDown($event)" pattern="^[0-9+]*$"
            (keyup)="onKeyUp($event)" id="mobile"
            placeholder="{{ configService.localeKeys?.['account.enter_number.text']}}" required>
        </div>
        <!-- mobile number errors -->
        @if (changePhoneForm.controls.mobile.invalid && (changePhoneForm.controls.mobile.dirty || changePhoneForm.controls.mobile.touched) && changePhoneForm.controls.mobile.errors.required) {
          <p class="input-placeholder error-block">{{ configService.localeKeys?.my_acc_err3_desc || 'Mobile Number is required.'}}</p>
        }
        @if (changePhoneForm.controls.mobile.hasError('minlength')) {
          <p class="input-placeholder error-block">{{ configService.localeKeys?.my_acc_err1_desc1 || 'Mobile Number must be at least'}} {{changePhoneForm.controls.mobile.errors.minlength.requiredLength}} {{ configService.localeKeys?.my_acc_err1_desc2 || 'characters long.'}}</p>
        }
        @if (changePhoneForm.controls.mobile.hasError('maxlength')) {
          <p class="input-placeholder error-block">{{ configService.localeKeys?.my_acc_err2_desc1 || 'Mobile Number cannot be longer than'}} {{changePhoneForm.controls.mobile.errors.maxlength.requiredLength}} {{ configService.localeKeys?.my_acc_err2_desc2 || 'characters.'}}</p>
        }
        <!-- mobile number errors END-->
        @if (selectedPhoneCodeObj?.login_with_mobile_enabled && settingsService?.loginWithMobileEnabled) {
          <label class="sms-verify-text">{{ configService.localeKeys?.['account.send_code_for_verific.text'] || 'We will send you code in sms for verification'}}</label>
        }
        <button (click)="sendVerficationRequest(false)" type="submit" [disabled]="changePhoneForm.invalid || hideButton" class="uk-button submit-btn">{{ (selectedPhoneCodeObj?.login_with_mobile_enabled && settingsService?.loginWithMobileEnabled) ? (configService.localeKeys?.my_acc_send_code_btn || "Send Me Verification Code") : ( configService.localeKeys?.edit_acc_btn_save_chng_def || 'Save Changes')}}</button>
      </form>
    </div>
  }
  <!-- Enter PIN pop up -->
  @if (step === 2) {
    <div class="input-container">
      <h2 class="uk-modal-title">{{ configService.localeKeys?.['email_verification.verification_code.text'] || 'Enter Verification Code'}}</h2>
      <p class="sub-text">{{ configService.localeKeys?.['account.enter_code_for_verific.text'] || 'Please enter your code to verify your phone number below.'}}</p>
      <div class="form-fields input-container">
        <div class="otp-container-class margin-otp">
          <ng-otp-input #ngOtpInput (onInputChange)="onPinChange($event)" [config]="config"></ng-otp-input>
        </div>
      </div>
      <div class="align-center">
        <a (click)="sendVerficationRequest(true)">
        {{ configService.localeKeys?.['account.resend_sms.btn'] || 'Resend SMS'}}
        @if (showResendSmsTimer) {
          <span>{{resendTime + ' ' + (configService.localeKeys?.['common_keys.sec.text'] || 'sec')}}</span>
        }
      </a>
    </div>
    <button type="button" (click)="sendVerficationCode()" [disabled]="enablePinBtn" class="uk-button submit-btn">
      {{ configService.localeKeys?.['account.verify_number.btn'] || 'Verify your number' }}
    </button>
  </div>
}
<!-- Success pop up -->
@if (step === 3) {
  <div>
    <app-success icon="/branding/theme/assets/static_assets/ic-success.svg" [toptext]="selectedPhoneCodeObj?.login_with_mobile_enabled && settingsService?.loginWithMobileEnabled ? configService.localeKeys?.['account.number_verified.text'] || 'Your phone number is verified.' : (configService.localeKeys?.my_acc_num_updated_title || 'Your phone number is updated')" [haslottie]="'true'">
    </app-success>
  </div>
}

</div>